import { Link } from "react-router-dom";
import { Wifi, WifiOff } from "lucide-react";
import { fmtTimeMYT } from "@/lib/traffic";
import { cn } from "@/lib/utils";

// Compact one-line strip of the latest radar offline / back-online notes for the Overview wall display.
export function RadarNotesStrip({ notes, sites }) {
  if (!notes?.length) return null;
  const nameOf = (id) => sites?.find((s) => s.site_id === id)?.name || id;
  const reason = (a) => (a.message.includes("—") ? a.message.split("—")[1].trim() : "");
  return (
    <div className="flex items-center gap-2 overflow-x-auto rounded-2xl border border-border/60 bg-secondary/30 px-3 py-1.5" data-testid="radar-notes-strip">
      <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">Radar notes</span>
      {notes.map((a) => {
        const online = a.kind === "radar_online";
        const resolved = !online && a.closed_at;
        return (
          <Link key={a.id} to="/radar-health" title={a.message} data-testid={`radar-note-${a.id}`}
            className={cn("flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] transition-colors",
              online ? "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-900/60 dark:bg-emerald-950/40 dark:text-emerald-200"
                : resolved ? "border-border bg-background text-muted-foreground"
                  : "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-900/60 dark:bg-rose-950/40 dark:text-rose-200")}>
            {online ? <Wifi className="h-3 w-3" /> : <WifiOff className="h-3 w-3" />}
            <span className="font-semibold">{a.site}</span>
            <span className="hidden max-w-[140px] truncate xl:inline">{nameOf(a.site)}</span>
            <span className="opacity-60">·</span>
            <span>{online ? "back online" : resolved ? "offline (resolved)" : `offline${reason(a) ? ` · ${reason(a)}` : ""}`}</span>
            <span className="num opacity-70">{fmtTimeMYT(a.opened_at)}</span>
          </Link>
        );
      })}
      <Link to="/alerts" className="ml-auto shrink-0 text-[11px] text-primary hover:underline" data-testid="radar-notes-all">All alerts →</Link>
    </div>
  );
}
